export default __webpack_public_path__ + "static/media/ag-title-cn.43893501.webp";